export default __webpack_public_path__ + "static/media/Locate_Black.7e13d1f7.webp";